import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import { useApp } from '../contexts/AppContext.jsx';

export default function ProtectedRoute({ children }) {
  const { user, loading: authLoading } = useAuth();
  const { interviewee, loading: appLoading } = useApp();
  const location = useLocation();

  if (authLoading || appLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-teal-600" />
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (interviewee?.career_onboarding_step !== 'complete') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
